import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getUserRole, ROLES, isAdmin as checkIsAdmin, isHandicapper as checkIsHandicapper } from '../services/roleService';

const RoleContext = createContext();

export function useRole() {
  return useContext(RoleContext);
}

export function RoleProvider({ children }) {
  const { currentUser } = useAuth();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadUserRole = async () => {
      if (!currentUser) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Force token refresh to get latest custom claims
        await currentUser.getIdToken(true);
        
        const userRole = await getUserRole(currentUser.uid);
        
        if (isMounted) {
          // If role is null (document doesn't exist yet), default to USER
          setRole(userRole || ROLES.USER);
        }
      } catch (error) {
        console.error('Error loading user role:', error);
        if (isMounted) {
          setRole(ROLES.USER); // Default to user role on error
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadUserRole();

    return () => {
      isMounted = false;
    };
  }, [currentUser]);

  const value = {
    role,
    loading,
    isAdmin: role === ROLES.ADMIN,
    isHandicapper: role === ROLES.HANDICAPPER,
    isUser: role === ROLES.USER,
    isHandicapperOrAdmin: role === ROLES.HANDICAPPER || role === ROLES.ADMIN
  };

  return (
    <RoleContext.Provider value={value}>
      {children}
    </RoleContext.Provider>
  );
}
